// extracted by mini-css-extract-plugin
export default {"App":"presets_App__pVOoA","loadingWrapper":"presets_loadingWrapper__rU7j5","loading":"presets_loading__TZncy","wrapper":"presets_wrapper__HFyFs","title":"presets_title__Cs9g6"};